export const caseStudies = [
  {
    slug: "ai-scheduler",
    title: "AI Scheduler",
    category: "Product Concept",
    summary:
      "A smart scheduling assistant concept designed to make planning, reminders and calendar management feel effortless.",
    stack: ["AI", "UX", "Prototype"],
    sections: {
      overview: "Add overview here.",
      problem: "Add problem here.",
      role: "Add your role here.",
      process: "Add process here.",
      features: ["Feature one", "Feature two", "Feature three"],
      learning: "Add what you learned here.",
    },
  },
  {
    slug: "therapease",
    title: "TherapEase",
    category: "UX/UI Capstone",
    summary:
      "TherapEase is a web application designed to simplify the administrative workload for therapists. It consolidates scheduling, client notes, payments and communication into one secure platform focused on usability, automation and user-centred design.",
    stack: ["MongoDB", "Express", "React", "Node.js", "Stripe", "Chart.js", "Speakeasy", "MERN", "Tailwind CSS", "BullMQ & Redis"],
    heroImage: "/therapease-dashboard.png",
    sections: {
      overview:
        "TherapEase brings core therapist workflows together in one place: client records, appointment scheduling, automated reminders, payment processing and Zoom link generation. The product was built as a 5‑month thesis project where I was the main developer, with a strong focus on usability and automation to reduce administrative overhead.",
      problem:
        "Many therapists rely on multiple disconnected tools for scheduling, notes, payments and communication. This fragmentation created inefficient workflows, task switching and increased administrative burden for clinicians — reducing time available for client care.",
      role:
        "Main developer and lead implementer for the project (thesis). I handled architecture, frontend and backend development, integrations (Stripe, Zoom, SMS/email automation), and user testing across the 5‑month build.",
      process:
        "Applied user‑centred design: conducted research, built wireframes and high‑fidelity prototypes, iterated with usability testing, and implemented the production MERN stack. Key phases: research & requirements, prototyping, development, integration (payments, 2FA, Zoom), and user testing with task‑based measurements.",
      features: [
        "Dashboard with customizable to‑do list, reminders, upcoming appointments and revenue snapshot",
        "Colour‑coded calendar with month/week/day views, appointment filters and a ‘create appointment’ modal with payment timing options",
        "Client profile page with full history, note editor, file storage, appointments and payment records",
        "Payments page with Stripe sandbox integration, payment link creation, reminders and Chart.js revenue graphs",
        "Client list table with status (active/inactive) and quick actions",
        "Two‑factor authentication via Speakeasy and QR code (GDPR/data protection requirement)",
        "Automations: email receipts/confirmations/updates and SMS reminders/payment links",
        "Zoom link generation for online sessions and secure links per appointment"
      ],
      learning:
        "Time‑on‑task testing showed a 70% reduction for the three most common administrative tasks (create client profile, schedule appointment, write session notes). The System Usability Scale returned a score of 97.5 — indicating an almost perfect UX. The research demonstrated that an integrated, user‑centred approach significantly reduces task switching and improves workflow efficiency for therapists."
    },
  },
  {
    slug: "campuspost",
    title: "CampusPost",
    category: "Product Concept",
    summary:
      "A student-centred social platform concept for campus communities, events, posts and connection.",
    stack: ["Social", "UI", "Frontend"],
    sections: {
      overview: "Add overview here.",
      problem: "Add problem here.",
      role: "Add your role here.",
      process: "Add process here.",
      features: ["Feature one", "Feature two", "Feature three"],
      learning: "Add what you learned here.",
    },
  },
];
